import { useState as u, useEffect as f } from "react";
const I = ({
  refElement: n,
  threshold: s = 0.1
}) => {
  const [o, i] = u(!1);
  return f(() => {
    const c = s ? { threshold: s } : { threshold: 0.1 }, e = n.current, r = new IntersectionObserver(([t]) => {
      t != null && t.isIntersecting && !o && i(!0);
    }, c);
    return e && r.observe(e), () => {
      e && r.unobserve(e);
    };
  }, [n, s]), o;
};
export {
  I as useSeenInViewport
};
